































































































































































































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import type { ConfiguracaoDeNotificacaoPorEmail, ConfiguracaoDeNotificacaoPorUsuario, FormLoja, Loja, Marca } from '@/models'
import { DeleteLojaUseCase, FindLojaUseCase, SaveLojaUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds'
import { criarLoja } from '@/shareds/loja-shareds'
import { formatarCnpjOuCpf } from '@/shareds/formatadores'
import {
	ASSUNTO_POR_ID,
	IdDoAssunto,
	PARAMETRO_POR_ID,
	PARAMETROS_DA_LOJA,
} from '@/shareds/nova-edicao-de-loja/catalogo-de-parametros'
import {
	CAMPOS_DE_CADASTRO,
	CampoDeCadastro,
	GRUPOS_DE_SECOES,
	IdDaSecao,
	SECAO_DA_ABA_ANTIGA,
	SECAO_POR_ID,
} from '@/shareds/nova-edicao-de-loja/secoes'
import { AlteracaoDaLoja, listarAlteracoes } from '@/shareds/nova-edicao-de-loja/alteracoes'
import { criarFiltroDaBusca, realcarBusca, textoDoCampo, textoDoParametro } from '@/shareds/nova-edicao-de-loja/busca'
import { montarLojaParaSalvar, validarLojaAntesDeSalvar } from '@/shareds/nova-edicao-de-loja/salvar-loja'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import TableDeSeriesFiscais from '@/components/loja/TableDeSeriesFiscais.vue'
import TableDeTiposDePagamento from '@/components/loja/TableDeTiposDePagamento.vue'
import ListagemDeClientesPorLoja from '@/components/cliente/ListagemDeClientesPorLoja.vue'
import ListagemDeMarcasPorLoja from '../EdicaoDeLoja/ListagemDeMarcasPorLoja.vue'
import ListagemDeLojasPorLoja from '../EdicaoDeLoja/ListagemDeLojasPorLoja.vue'
import TabDeEnvioDeEmail from '../EdicaoDeLoja/TabDeEnvioDeEmail.vue'
import TabDeTabelaDePreco from '../EdicaoDeLoja/TabDeTabelaDePreco.vue'
import DialogoDeImportacaoDeOutrasLojas from '../EdicaoDeLoja/DialogoDeImportacaoDeOutrasLojas.vue'
import ListaDeParametros from './ListaDeParametros.vue'
import BarraDeSalvarDaLoja from './BarraDeSalvarDaLoja.vue'
import SecaoDadosDaLoja from './SecaoDadosDaLoja.vue'
import SecaoFuncionarios from './SecaoFuncionarios.vue'
import SecaoEnderecoEContato from './SecaoEnderecoEContato.vue'
import SecaoDadosFiscais from './SecaoDadosFiscais.vue'
import SecaoPontosDeVenda from './SecaoPontosDeVenda.vue'
import SecaoComandas from './SecaoComandas.vue'
import SecaoNps from './SecaoNps.vue'
import BlocoProcon from './BlocoProcon.vue'
import BlocoPoliticaDeTroca from './BlocoPoliticaDeTroca.vue'
import BlocoServidorDeEmail from './BlocoServidorDeEmail.vue'

function copia<T>(valor: T): T {
	return JSON.parse(JSON.stringify(valor))
}

const TEXTO_DO_PARAMETRO = PARAMETROS_DA_LOJA.reduce(
	(mapa, parametro) => ({ ...mapa, [parametro.id]: textoDoParametro(parametro) }),
	{} as Record<string, string>,
)
const TEXTO_DO_CAMPO = CAMPOS_DE_CADASTRO.reduce(
	(mapa, campo) => ({ ...mapa, [campo.id]: textoDoCampo(campo) }),
	{} as Record<string, string>,
)

@Component({
	components: {
		Confirmacao,
		TableDeSeriesFiscais,
		TableDeTiposDePagamento,
		ListagemDeClientesPorLoja,
		ListagemDeMarcasPorLoja,
		ListagemDeLojasPorLoja,
		TabDeEnvioDeEmail,
		TabDeTabelaDePreco,
		DialogoDeImportacaoDeOutrasLojas,
		ListaDeParametros,
		BarraDeSalvarDaLoja,
		SecaoDadosDaLoja,
		SecaoFuncionarios,
		SecaoEnderecoEContato,
		SecaoDadosFiscais,
		SecaoPontosDeVenda,
		SecaoComandas,
		SecaoNps,
		BlocoProcon,
		BlocoPoliticaDeTroca,
		BlocoServidorDeEmail,
	},
})
export default class NovaEdicaoDeLoja extends Vue {
	@Prop({ type: Boolean }) novo!: boolean
	@Prop({ type: String, default: '' }) id!: string
	@Ref() formulario!: { validate: () => boolean; resetValidation: () => void; inputs: Vue[] }
	@Ref() confirmacaoDeSaida!: Confirmacao

	ASSUNTO_POR_ID = ASSUNTO_POR_ID

	loja: FormLoja | null = null
	versaoAnterior: FormLoja | null = null
	carregando = false
	salvando = false
	excluindo = false
	erro: Error | null = null
	secaoAtual: IdDaSecao = 'dados'
	/** O parâmetro que pisca ao chegar por link, busca ou pela lista de alterações. */
	destaque: string | null = null
	textoDaBusca = ''
	busca = ''
	temporizadorDaBusca: ReturnType<typeof setTimeout> | null = null
	emailsAlterados = false
	observandoEmails = false
	lojasDoGrupoEconomico: Loja[] = []
	carregandoLojasDoGrupoEconomico = false
	configuracoesDeNotificacaoPorUsuario: ConfiguracaoDeNotificacaoPorUsuario[] = []
	configuracoesDeNotificacaoPorEmail: ConfiguracaoDeNotificacaoPorEmail[] = []
	padrao = criarLoja().configuracaoDaLoja

	findUseCase = new FindLojaUseCase()
	saveUseCase = new SaveLojaUseCase()
	deleteUseCase = new DeleteLojaUseCase()

	/** Ref dentro do v-for das seções: o Vue entrega uma lista, mesmo com um componente só. */
	componenteDaSecao<T>(ref: string): T | undefined {
		const encontrado = this.$refs[ref] as T | T[] | undefined
		return Array.isArray(encontrado) ? encontrado[0] : encontrado
	}

	get podeEditar() {
		// temAutorizacao devolve a permissão encontrada (texto), não um booleano
		return !!UserLoginStore.temAutorizacao(montarOperacaoDeRecurso(this.novo ? 'criar' : 'alterar', 'lojas'))
	}

	get temAcessoIrrestrito() {
		return !!UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	get subtitulo() {
		if (!this.loja) return ''
		if (this.novo && !this.loja.cnpj) return 'Preencha os dados e salve para criar a loja.'
		const cnpj = this.loja.cnpj ? `CNPJ ${formatarCnpjOuCpf(this.loja.cnpj)}` : ''
		return [this.loja.razaoSocial, cnpj].filter(Boolean).join(', ')
	}

	get gruposVisiveis() {
		return GRUPOS_DE_SECOES
	}

	get secoesVisiveis() {
		return this.gruposVisiveis.reduce((secoes, grupo) => secoes.concat(grupo.secoes), [] as typeof GRUPOS_DE_SECOES[0]['secoes'])
	}

	get parametrosPermitidos() {
		return PARAMETROS_DA_LOJA.filter(parametro => !parametro.restrito || this.temAcessoIrrestrito)
	}

	propriedadesDaLista(assunto: IdDoAssunto) {
		return {
			parametros: this.parametrosPermitidos.filter(parametro => parametro.assunto === assunto),
			loja: this.loja,
			anterior: this.versaoAnterior,
			padrao: this.padrao,
			destaque: this.destaque,
			lojasDoGrupoEconomico: this.lojasDoGrupoEconomico,
			carregandoLojasDoGrupoEconomico: this.carregandoLojasDoGrupoEconomico,
		}
	}

	get alteracoes(): AlteracaoDaLoja[] {
		const alteracoes = listarAlteracoes(this.versaoAnterior, this.loja)
		if (this.emailsAlterados) {
			alteracoes.push({ id: 'emailsAutomaticos', titulo: 'E-mails automáticos para o cliente', secao: 'email' })
		}
		return alteracoes
	}

	get alteracoesPorSecao() {
		return this.alteracoes.reduce(
			(contagem, { secao }) => ({ ...contagem, [secao]: (contagem[secao] || 0) + 1 }),
			{} as Record<string, number>,
		)
	}

	get buscando() {
		return !!this.busca.trim()
	}

	campoDisponivel(campo: CampoDeCadastro) {
		if (campo.id === 'excluirLoja') return !this.novo
		if (campo.id === 'comandas') return !!this.loja && this.loja.configuracaoDaLoja.trabalharComRomaneio
		return true
	}

	get resultadosDaBusca() {
		if (!this.buscando) return []
		const campos = CAMPOS_DE_CADASTRO.filter(campo => this.campoDisponivel(campo))
		const casa = criarFiltroDaBusca(this.busca, [
			...this.parametrosPermitidos.map(({ id }) => TEXTO_DO_PARAMETRO[id]),
			...campos.map(({ id }) => TEXTO_DO_CAMPO[id]),
		])
		return this.gruposVisiveis
			.reduce((resultados, grupo) => resultados.concat(grupo.secoes.map(secao => ({
				secao,
				grupo: grupo.titulo,
				parametros: secao.assunto
					? this.parametrosPermitidos.filter(({ id, assunto }) => assunto === secao.assunto && casa(TEXTO_DO_PARAMETRO[id]))
					: [],
				campos: campos.filter(campo => campo.secao === secao.id && casa(TEXTO_DO_CAMPO[campo.id])),
			}))), [] as { secao: typeof GRUPOS_DE_SECOES[0]['secoes'][0]; grupo: string; parametros: typeof PARAMETROS_DA_LOJA; campos: CampoDeCadastro[] }[])
			.filter(({ parametros, campos }) => parametros.length || campos.length)
	}

	get resumoDaBusca() {
		const total = this.resultadosDaBusca.reduce((soma, { parametros, campos }) => soma + parametros.length + campos.length, 0)
		if (!total) return ''
		const secoes = this.resultadosDaBusca.length
		return `${total === 1 ? '1 resultado' : `${total} resultados`} com "${this.busca}" em ${secoes === 1 ? '1 seção' : `${secoes} seções`} da loja`
	}

	realcar(texto: string) {
		return realcarBusca(texto, this.busca)
	}

	digitarBusca(texto: string | null) {
		this.textoDaBusca = texto || ''
		if (this.temporizadorDaBusca) clearTimeout(this.temporizadorDaBusca)
		this.temporizadorDaBusca = setTimeout(() => {
			this.busca = this.textoDaBusca
		}, texto ? 150 : 0)
	}

	@Watch('id', { immediate: true })
	aoTrocarALoja() {
		this.carregar()
	}

	@Watch('loja.grupoEconomico.id', { immediate: true })
	async carregarLojasDoGrupoEconomico() {
		const grupoEconomicoId = this.loja?.grupoEconomico?.id
		if (!grupoEconomicoId) {
			this.lojasDoGrupoEconomico = []
			return
		}
		try {
			this.carregandoLojasDoGrupoEconomico = true
			const pagina = await this.findUseCase.findLojasByGrupoEconomicoId(grupoEconomicoId, { params: { size: 200 } })
			this.lojasDoGrupoEconomico = pagina.content.filter(({ id }) => id !== this.loja?.id)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregandoLojasDoGrupoEconomico = false
		}
	}

	async carregar() {
		try {
			this.carregando = true
			this.erro = null
			const loja = this.novo ? criarLoja() : await this.findUseCase.findLojaById(this.id)
			loja.avaliacaoNpsConfig = [...(loja.avaliacaoNpsConfig || [])].sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
			if (loja.id) {
				this.configuracoesDeNotificacaoPorUsuario = await this.findUseCase.findConfigDeNotificacaoPorUsuario(loja.id)
				this.configuracoesDeNotificacaoPorEmail = await this.findUseCase.findConfigDeNotificacaoPorEmail(loja.id)
			}
			const primeiraCarga = !this.loja
			this.loja = loja
			this.versaoAnterior = copia(loja)
			if (primeiraCarga) this.aplicarRota()
			await this.$nextTick()
			// Ao desenhar, os campos com máscara (CNPJ, telefone, CEP) reescrevem o valor e a tabela de formas de pagamento
			// reordena a lista. O que conta como salvo é a loja como ficou na tela: Descartar devolvia o CNPJ sem máscara
			this.versaoAnterior = copia(this.loja)
			this.observarEmailsAutomaticos()
		} catch (error) {
			this.erro = error as Error
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	/** O formulário de e-mails automáticos guarda o próprio estado; a contagem de alterações pergunta a ele. */
	observarEmailsAutomaticos() {
		const tab = this.componenteDaSecao<{ alterado?: boolean }>('tabDeEnvioDeEmail')
		if (this.observandoEmails || !tab) return
		this.observandoEmails = true
		this.$watch(() => !!tab.alterado, alterado => {
			this.emailsAlterados = alterado
		}, { immediate: true })
	}

	/** ?secao= e ?p= da nova tela; ?t= dos links da tela antiga. */
	aplicarRota() {
		const { secao, p, t } = this.$route.query
		const parametro = typeof p === 'string' ? PARAMETRO_POR_ID[p] : undefined
		if (parametro) {
			this.abrirSecao(parametro.assunto as IdDaSecao, { parametro: parametro.id })
			return
		}
		if (typeof secao === 'string' && SECAO_POR_ID[secao as IdDaSecao]) {
			this.secaoAtual = secao as IdDaSecao
			return
		}
		if (typeof t === 'string' && SECAO_DA_ABA_ANTIGA[t]) this.secaoAtual = SECAO_DA_ABA_ANTIGA[t]
	}

	abrirSecao(secao: IdDaSecao, alvo: { parametro?: string; campo?: string } = {}) {
		this.digitarBusca('')
		this.busca = ''
		this.secaoAtual = secao
		const query = { ...this.$route.query, secao, p: alvo.parametro } as Record<string, string | undefined>
		delete query.t
		if (!alvo.parametro) delete query.p
		if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
			this.$router.replace({ query: query as Record<string, string> }).catch(() => undefined)
		}
		this.$nextTick(() => {
			const elementoDaSecao = this.$el.querySelector(`[data-secao="${secao}"]`)
			if (!elementoDaSecao) return
			const alvoNaTela = alvo.parametro
				? elementoDaSecao.querySelector(`#parametro-${alvo.parametro}`)
				: alvo.campo
					? elementoDaSecao.querySelector(`#campo-${alvo.campo}`)
					: null
			if (!alvoNaTela) {
				window.scrollTo({ top: 0 })
				return
			}
			alvoNaTela.scrollIntoView({ block: 'center' })
			if (alvo.parametro) {
				this.destaque = null
				this.$nextTick(() => {
					this.destaque = alvo.parametro || null
				})
			} else {
				alvoNaTela.classList.remove('tl-ancora--destaque')
				void (alvoNaTela as HTMLElement).offsetWidth
				alvoNaTela.classList.add('tl-ancora--destaque')
				const campoDeTexto = alvoNaTela.querySelector('input, textarea') as HTMLElement | null
				if (campoDeTexto) campoDeTexto.focus({ preventScroll: true })
			}
		})
	}

	abrirCampo(campo: CampoDeCadastro) {
		this.abrirSecao(campo.secao, { campo: campo.id })
	}

	irParaAlteracao(alteracao: AlteracaoDaLoja) {
		if (PARAMETRO_POR_ID[alteracao.id]) {
			this.abrirSecao(alteracao.secao, { parametro: alteracao.id })
			return
		}
		this.abrirSecao(alteracao.secao, { campo: alteracao.id })
	}

	adicionarMarcas(marcas: Marca[]) {
		if (!this.loja) return
		this.loja.marcas.push(...marcas)
	}

	removerMarca(marca: Marca) {
		if (!this.loja) return
		const indice = this.loja.marcas.findIndex(({ id }) => id === marca.id)
		if (indice !== -1) this.loja.marcas.splice(indice, 1)
	}

	copiarFormasDePagamento() {
		const dialogo = this.componenteDaSecao<DialogoDeImportacaoDeOutrasLojas>('dialogoDeImportacao')
		if (dialogo) dialogo.mostrar()
	}

	/** A seção do primeiro campo com erro, para abrir e mostrar onde está. */
	secaoDoPrimeiroErro(): { secao: IdDaSecao; input: Vue } | null {
		const comErro = this.formulario.inputs.find(input => {
			const validavel = input as unknown as { hasError: boolean }
			return validavel.hasError && input.$el.closest('[data-secao]')
		})
		if (!comErro) return null
		const elemento = comErro.$el.closest('[data-secao]') as HTMLElement
		return { secao: elemento.dataset.secao as IdDaSecao, input: comErro }
	}

	/** Grava a loja; devolve se gravou, para quem troca de tela depois de salvar. */
	async salvar(): Promise<boolean> {
		// Sem a permissão de alterar loja não há o que gravar, venha o pedido da barra ou da troca de tela
		if (!this.loja || this.salvando || !this.podeEditar) return false
		if (!this.formulario.validate()) {
			const erro = this.secaoDoPrimeiroErro()
			if (erro) {
				this.abrirSecao(erro.secao)
				setTimeout(() => {
					erro.input.$el.scrollIntoView({ block: 'center' })
					const campo = erro.input as unknown as { focus?: () => void }
					if (campo.focus) campo.focus()
				}, 50)
				AlertModule.setError(`Confira o campo marcado em ${SECAO_POR_ID[erro.secao].titulo}.`)
			}
			return false
		}
		const problema = validarLojaAntesDeSalvar(this.loja)
		if (problema) {
			this.abrirSecao(problema.secao)
			AlertModule.setError(problema.mensagem)
			return false
		}
		try {
			this.salvando = true
			const lojaSalva = await this.saveUseCase.save(montarLojaParaSalvar(this.loja))
			let emailsSalvos = true
			try {
				const emails = this.componenteDaSecao<TabDeEnvioDeEmail>('tabDeEnvioDeEmail')
				if (emails) await emails.salvar()
			} catch (error) {
				emailsSalvos = false
				this.abrirSecao('email')
				AlertModule.setError(error)
			}
			if (this.novo) {
				// A loja criada abre pela rota dela; sem pendência, a saída desta rota não pede confirmação
				this.versaoAnterior = copia(this.loja)
				if (emailsSalvos) AlertModule.setSuccess('Loja salva com sucesso')
				await this.$router.push({ name: 'Loja', params: { id: lojaSalva.id } })
				return emailsSalvos
			}
			await this.carregar()
			if (emailsSalvos) AlertModule.setSuccess('Loja salva com sucesso')
			return emailsSalvos
		} catch (error) {
			// Diferente da tela antiga, o que foi digitado continua na tela para corrigir e salvar de novo
			AlertModule.setError(error)
			return false
		} finally {
			this.salvando = false
		}
	}

	descartar() {
		if (!this.versaoAnterior) return
		this.loja = copia(this.versaoAnterior)
		const tab = this.componenteDaSecao<{ carregar?: () => void }>('tabDeEnvioDeEmail')
		if (tab && tab.carregar) tab.carregar()
		this.formulario.resetValidation()
	}

	/** Para a saída da rota: sem pendência sai direto; com pendência, pergunta como a tela antiga. */
	async podeSair(): Promise<boolean> {
		if (!this.alteracoes.length) return true
		return !!(await this.confirmacaoDeSaida.mostrar())
	}

	async excluirLoja() {
		try {
			this.excluindo = true
			await this.deleteUseCase.delete(this.id)
			this.versaoAnterior = this.loja ? copia(this.loja) : null
			await this.$router.push({ name: 'Lojas' })
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.excluindo = false
		}
	}
}
